import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Helper to get full image URL from relative path
export const getImageUrl = (path) => {
  if (!path) return null;
  // If it's already a full URL (http/https), return as-is
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }
  // If it's a relative path starting with /api, prepend backend URL
  if (path.startsWith('/api/')) {
    return `${BACKEND_URL}${path}`;
  }
  // Otherwise, return as-is
  return path;
};

// API helper
export const api = {
  get: async (url) => {
    const token = localStorage.getItem("token");
    return axios.get(`${API}${url}`, { 
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
  },
  post: async (url, data, config = {}) => {
    const token = localStorage.getItem("token");
    return axios.post(`${API}${url}`, data, { 
      headers: token ? { Authorization: `Bearer ${token}`, ...config.headers } : config.headers,
      ...config
    });
  },
  delete: async (url) => {
    const token = localStorage.getItem("token");
    return axios.delete(`${API}${url}`, { 
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
  },
  put: async (url, data) => {
    const token = localStorage.getItem("token");
    return axios.put(`${API}${url}`, data, { 
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
  }
};

export default api;
